import { useParams } from "react-router-dom";
import RepresentantForm from "../../components/Profile/RepresentantForm";
import type { Profile as ProfileType } from "../../components/Profile/types";
// @ts-expect-error pure js
import { useModal } from "../../hooks/use-modal.jsx";
// @ts-expect-error pure js
import { Profile } from "../../models/profile";
// @ts-expect-error pure js
import { useTenantProfiles } from "../../hooks/use-profiles-indiv";

export default function AddRepresentantPage() {
  const [Modal, closeModal] = useModal(true);

  const { tenantId, profileId } = useParams();
  const { createProfile } = useTenantProfiles(tenantId);

  return (
    <RepresentantForm
      modal={Modal}
      onSubmit={async (data: ProfileType) => {
        const profile = Profile.create(data);
        profile.legal_representative_of = parseInt(profileId ?? "", 10);
        await createProfile(profile);
        closeModal();
      }}
    />
  );
}
